function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { includes as contains, values } from 'ramda';
import moment from 'moment';
import { AddressHelper, i18n, LogHelper, MetadataConstants } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { ADD_TO_BLOCKLIST_MENU_ID, ADD_TO_ALLOWLIST_MENU_ID, PAYMENT_METHOD_STATUSES, REACTIVATE_PAYMENT_METHOD_OPTION_ID, OPT_OUT_REACTIVATE_PAYMENT_INSTRUMENT_TYPES, REMOVE_FROM_BLOCKLIST_MENU_ID, REMOVE_FROM_ALLOWLIST_MENU_ID, REMOVE_PAYMENT_METHOD_OPTION_ID, ANONYMIZE_PAYMENT_METHOD_OPTION_ID, SET_AS_DEFAULT_PAYMENT_METHOD_OPTION_ID, SUPPORTED_PAYMENT_INSTRUMENT_TYPES, VIEW_TRANSACTION_HISTORY_MENU_ID } from '../ewallet.constants';
import { paymentTypeNameIdentifier } from '../ewallet.helpers';
import BWConstants from '../modals/blocklist.allowlist.constants';
import { paymentInstrumentCanBeSetAsDefault, showAddToBlocklist, showRemoveFromBlocklist, showAddToAllowlist, showRemoveFromAllowlist } from './more.menu.helpers';
var removePaymentMethodConfPopupApi = null;
var removePaymentMethodErrorPopupApi = null;
var anonymizePaymentMethodConfPopupApi = null;
var anonymizePaymentMethodErrorPopupApi = null;
var updateSubscriptionsConfPopupApi = null;
var activatePaymentMethodErrorPopupApi = null;
var setDefaultPaymentMethodErrorPopupApi = null;
var bwModalPopupApi = null;
var bwModalErrorPopupApi = null;
var EwalletDetailController = /*#__PURE__*/function () {
  function EwalletDetailController(uiNotificationService, $timeout) {
    _classCallCheck(this, EwalletDetailController);
    Object.assign(this, {
      $timeout: $timeout,
      uiNotificationService: uiNotificationService,
      localeKeys: CustomerCareLocaleKeys,
      paymentTypeNameIdentifier: paymentTypeNameIdentifier,
      showBWModal: false,
      paymentInstrumentTypes: SUPPORTED_PAYMENT_INSTRUMENT_TYPES
    });
  }
  return _createClass(EwalletDetailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.awaitingAsyncRemovePaymentMethod = false;
      this.awaitingAsyncAnonymizePaymentMethod = false;
      this.buildMoreMenuOptions();
      this.removePaymentMethodConfPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          removePaymentMethodConfPopupApi = event.api;
        }
      };
      this.removePaymentMethodErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          removePaymentMethodErrorPopupApi = event.api;
        }
      };
      this.anonymizePaymentMethodConfPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          anonymizePaymentMethodConfPopupApi = event.api;
        }
      };
      this.anonymizePaymentMethodErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          anonymizePaymentMethodErrorPopupApi = event.api;
        }
      };
      this.updateSubscriptionsConfPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          updateSubscriptionsConfPopupApi = event.api;
        }
      };
      this.activatePaymentMethodErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          activatePaymentMethodErrorPopupApi = event.api;
        }
      };
      this.setDefaultPaymentMethodErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          setDefaultPaymentMethodErrorPopupApi = event.api;
        }
      };
      this.bwModalPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          bwModalPopupApi = event.api;
        }
      };
      this.bwModalErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          bwModalErrorPopupApi = event.api;
        }
      };
      this.handleResultRemovePaymentMethodConfirmationPopup = function (isConfirmed) {
        if (_this.awaitingAsyncRemovePaymentMethod) {
          LogHelper('remove submitted while awaiting async op: funk awaits');
        }
        if (isConfirmed) {
          _this.awaitingAsyncRemovePaymentMethod = true;
          removePaymentMethodConfPopupApi.close();
          // NOTE: inv-popup and inv-confirmation-dialog don't interop;
          // encapsulate the "close on action" concern here, via promises
          var initialPromise = _this.paymentMethodRemove()(_this.currentCustomerId, _this.paymentMethod.Id);
          var endAsyncRemovPaymentMethod = function endAsyncRemovPaymentMethod() {
            _this.awaitingAsyncRemovePaymentMethod = false;
            return initialPromise;
          };
          // actual fulfill/reject handler for inv-confirmation-dialog action
          return initialPromise.then(endAsyncRemovPaymentMethod, endAsyncRemovPaymentMethod).then(function () {
            _this.uiNotificationService.transientSuccess(i18n.translate(CustomerCareLocaleKeys.E_WALLET.REMOVE_SUCCESS_MESSAGE));
            var onPaymentMethodRemoved = _this.onPaymentMethodRemoved();
            onPaymentMethodRemoved && onPaymentMethodRemoved(_this.paymentMethod);
          }, function () {
            removePaymentMethodErrorPopupApi.open();
          });
        } else {
          // user clicked cancel
          removePaymentMethodConfPopupApi.close();
        }
      };
      this.handleResultAnonymizePaymentMethodConfirmationPopup = function (isConfirmed) {
        if (_this.awaitingAsyncAnonymizePaymentMethod) {
          LogHelper('anonymize submitted while awaiting async op');
        }
        if (isConfirmed) {
          _this.awaitingAsyncAnonymizePaymentMethod = true;
          anonymizePaymentMethodConfPopupApi.close();
          // NOTE: inv-popup and inv-confirmation-dialog don't interop;
          // encapsulate the "close on action" concern here, via promises
          var initialPromise = _this.paymentMethodAnonymize()(_this.currentCustomerId, _this.paymentMethod.Id);
          var endAsyncAnonymizePaymentMethod = function endAsyncAnonymizePaymentMethod() {
            _this.awaitingAsyncAnonymizePaymentMethod = false;
            return initialPromise;
          };
          // actual fulfill/reject handler for inv-confirmation-dialog action
          return initialPromise.then(endAsyncAnonymizePaymentMethod, endAsyncAnonymizePaymentMethod).then(function () {
            _this.uiNotificationService.transientSuccess(i18n.translate(CustomerCareLocaleKeys.E_WALLET.ANONYMIZE_SUCCESS_MESSAGE));
            var onPaymentMethodAnonymized = _this.onPaymentMethodAnonymized();
            onPaymentMethodAnonymized && onPaymentMethodAnonymized(_this.paymentMethod);
          }, function () {
            anonymizePaymentMethodErrorPopupApi.open();
          });
        } else {
          // user clicked cancel
          anonymizePaymentMethodConfPopupApi.close();
        }
      };
      this.activatePaymentMethod = function () {
        var initialPromise = _this.activatePaymentInstrument()(_this.currentCustomerId, _this.paymentMethod);
        var endAsyncActivatePaymentMethod = function endAsyncActivatePaymentMethod() {
          return initialPromise;
        };
        // actual fulfill/reject handler for inv-confirmation-dialog action
        return initialPromise.then(endAsyncActivatePaymentMethod, endAsyncActivatePaymentMethod).then(function () {
          _this.uiNotificationService.transientSuccess(i18n.translate(CustomerCareLocaleKeys.E_WALLET.ACTIVATE_SUCCESS_MESSAGE));
        }, function () {
          activatePaymentMethodErrorPopupApi.open();
        });
      };
      this.handleResultUpdateSubscriptionsConfirmationPopup = function (isConfirmed) {
        _this.setPaymentMethodAsDefault(isConfirmed);
        updateSubscriptionsConfPopupApi.close();
      };
      this.handleCloseBWModalPopup = function (shouldUpdatePaymentMethod, error) {
        _this.$timeout(function () {
          bwModalPopupApi.close();
          if (error) {
            bwModalErrorPopupApi.open();
          }
        });
        if (shouldUpdatePaymentMethod) {
          _this.onPaymentMethodUpdated()();
        }
        _this.showBWModal = false;
      };
      this.handleResultRemovePaymentMethodConfirmationPopup.bind(this);
      this.handleResultAnonymizePaymentMethodConfirmationPopup.bind(this);
      this.handleMoreOptionsMenuSelected.bind(this);
      this.activatePaymentMethod.bind(this);
      if (!this.braintreeMethodTypesLoaded) {
        this.fetchCodeType()(MetadataConstants.codes.BraintreeMethodType);
      }
      if (!this.brandableCurrenciesLoaded) {
        this.fetchCodeType()(MetadataConstants.codes.BrandableCurrency);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      this.buildMoreMenuOptions();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      bwModalPopupApi.close();
    }
  }, {
    key: "formattedCreditCardExpiration",
    get: function get() {
      if (!this.paymentMethod) {
        return '';
      }
      var _this$paymentMethod$C = this.paymentMethod.CreditCard,
        ExpirationMonth = _this$paymentMethod$C.ExpirationMonth,
        ExpirationYear = _this$paymentMethod$C.ExpirationYear;
      return "".concat(ExpirationMonth, "/").concat(ExpirationYear.slice(-2));
    }
  }, {
    key: "isStripeCreditCardExpired",
    get: function get() {
      return moment(this.paymentInstrument.StripeAccount.CardExpirationDate, 'MM/YYYY').isBefore(moment(), 'month');
    }
  }, {
    key: "formattedBillingCityState",
    get: function get() {
      if (!this.paymentMethod) {
        return '';
      }
      var _ref = this.paymentMethod.BillingAddress || {},
        _ref$City = _ref.City,
        City = _ref$City === void 0 ? '' : _ref$City,
        _ref$State = _ref.State,
        State = _ref$State === void 0 ? '' : _ref$State,
        _ref$Country = _ref.Country,
        Country = _ref$Country === void 0 ? '' : _ref$Country,
        _ref$PostalCode = _ref.PostalCode,
        PostalCode = _ref$PostalCode === void 0 ? '' : _ref$PostalCode;
      var countryAndPostalCode = AddressHelper.formatCountryAndPostalCode(Country, PostalCode).countryAndPostalCode;
      return "".concat(City ? "".concat(City, ", ") : '').concat(State ? "".concat(State, ", ") : '').concat(countryAndPostalCode);
    }
  }, {
    key: "removePaymentMethodMessage",
    get: function get() {
      return !this.autopayEnableForPaymentMethod ? this.localeKeys.E_WALLET.CONFIRM_REMOVE_MESSAGE : this.localeKeys.E_WALLET.CONFIRM_REMOVE_AUTO_PAY_MESSAGE;
    }
  }, {
    key: "isCreditCard",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD && this.paymentMethod.CreditCard;
    }
  }, {
    key: "isGiftCard",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD && this.paymentMethod.GiftCard;
    }
  }, {
    key: "isExternalGiftCard",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD && this.paymentMethod.ExternalGiftCard;
    }
  }, {
    key: "isPayPal",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.PAY_PAL && this.paymentMethod.PayPalAccount;
    }
  }, {
    key: "isItunes",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ITUNES && this.paymentMethod.ITunesAccount;
    }
  }, {
    key: "isStripeAccount",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STRIPE_ACCOUNT && this.paymentMethod.StripeAccount;
    }
  }, {
    key: "isExpired",
    get: function get() {
      return moment(this.formattedCreditCardExpiration, 'MM/YY').isBefore(moment(), 'month');
    }
  }, {
    key: "hasAdditionalStatus",
    get: function get() {
      return this.paymentMethod.Default || this.paymentMethod.Blocklisted || this.paymentMethod.Allowlisted;
    }
  }, {
    key: "isLocked",
    get: function get() {
      return Boolean(this.paymentMethod.Locked);
    }
  }, {
    key: "canEdit",
    get: function get() {
      var baseEditPermission = this.userHasAdminPermission() && this.currentSubHasEditPermission && this.paymentMethod.actionables.canEdit && this.isEwalletEditable;
      if (String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD) {
        return baseEditPermission && this.paymentMethod.requiresBillingAddress;
      } else {
        return baseEditPermission;
      }
    }
  }, {
    key: "canRemove",
    get: function get() {
      return this.userHasAdminPermission() && this.currentSubHasEditPermission && !this.isLocked;
    }
  }, {
    key: "canReactivate",
    get: function get() {
      var isPaymentTypeOptedOut = contains(String(this.paymentMethod.Type), values(OPT_OUT_REACTIVATE_PAYMENT_INSTRUMENT_TYPES));
      return !isPaymentTypeOptedOut && this.userHasAdminPermission() && this.currentSubHasEditPermission && !this.paymentMethod.Blocklisted && !this.isCreditCardWithEmptyAccountNumber;
    }
  }, {
    key: "canBlocklist",
    get: function get() {
      return this.userHasAdminPermission() && this.currentSubHasEditPermission;
    }
  }, {
    key: "isActivePaymentMethod",
    get: function get() {
      return this.paymentMethod.Status === PAYMENT_METHOD_STATUSES.ACTIVE;
    }
  }, {
    key: "canSetDefaultPaymentMethod",
    get: function get() {
      return this.isActivePaymentMethod && !this.paymentMethod.Default && this.userHasAdminPermission() && paymentInstrumentCanBeSetAsDefault(this.paymentMethod);
    }
  }, {
    key: "hasMoreMenuOptions",
    get: function get() {
      return this.moreOptionsMenuItems.length > 0;
    }
  }, {
    key: "isCreditCardWithEmptyAccountNumber",
    get: function get() {
      return String(this.paymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD && !this.paymentMethod.CreditCard.AccountNumber;
    }
  }, {
    key: "handleEditPaymentMethodClicked",
    value: function handleEditPaymentMethodClicked() {
      this.editPaymentMethod(this.paymentMethod);
    }
  }, {
    key: "setPaymentMethodAsDefault",
    value: function setPaymentMethodAsDefault(applyToSubscriptions) {
      var _this2 = this;
      var initialPromise = this.setPaymentInstrumentDefault()(this.currentCustomerId, this.paymentMethod, applyToSubscriptions);
      var endAsyncSetDefaultPaymentMethod = function endAsyncSetDefaultPaymentMethod() {
        return initialPromise;
      };
      // actual fulfill/reject handler for inv-confirmation-dialog action
      return initialPromise.then(endAsyncSetDefaultPaymentMethod, endAsyncSetDefaultPaymentMethod).then(function () {
        _this2.uiNotificationService.transientSuccess(i18n.translate(CustomerCareLocaleKeys.E_WALLET.SET_DEFAULT_SUCCESS_MESSAGE));
      }, function () {
        setDefaultPaymentMethodErrorPopupApi.open();
      });
    }
  }, {
    key: "handleSetPaymentMethodAsDefault",
    value: function handleSetPaymentMethodAsDefault() {
      if (this.defaultPaymentMethodHasSubscriptions && !this.defaultPaymentMethodIsReadOnly && this.currentPaymentMethodIsDirectSource) {
        updateSubscriptionsConfPopupApi.open();
      } else {
        this.setPaymentMethodAsDefault(false);
      }
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(item) {
      var selectedPaymentMethod = {
        id: this.paymentMethod.Id,
        value: this.paymentMethod.Id,
        text: this.paymentMethod.Name
      };
      switch (item.item.id) {
        case VIEW_TRANSACTION_HISTORY_MENU_ID:
          this.setPaymentInstrumentFilter()(selectedPaymentMethod);
          this.stateGo()('index.customercare.customer.transactions.list', {
            selectedPaymentId: this.paymentMethod.Id
          });
          break;
        case ADD_TO_BLOCKLIST_MENU_ID:
          this.modalState = BWConstants.STATE_ADD_TO_BLOCKLIST;
          this.showBWModal = true;
          this.$timeout(function () {
            bwModalPopupApi.open();
          });
          break;
        case ADD_TO_ALLOWLIST_MENU_ID:
          this.modalState = BWConstants.STATE_ADD_TO_ALLOWLIST;
          this.showBWModal = true;
          this.$timeout(function () {
            bwModalPopupApi.open();
          });
          break;
        case REMOVE_FROM_BLOCKLIST_MENU_ID:
          this.modalState = BWConstants.STATE_REMOVE_FROM_BLOCKLIST;
          this.showBWModal = true;
          this.$timeout(function () {
            bwModalPopupApi.open();
          });
          break;
        case REMOVE_FROM_ALLOWLIST_MENU_ID:
          this.modalState = BWConstants.STATE_REMOVE_FROM_ALLOWLIST;
          this.showBWModal = true;
          this.$timeout(function () {
            bwModalPopupApi.open();
          });
          break;
        case REMOVE_PAYMENT_METHOD_OPTION_ID:
          removePaymentMethodConfPopupApi.open();
          break;
        case ANONYMIZE_PAYMENT_METHOD_OPTION_ID:
          anonymizePaymentMethodConfPopupApi.open();
          break;
        case REACTIVATE_PAYMENT_METHOD_OPTION_ID:
          this.activatePaymentMethod();
          break;
        case SET_AS_DEFAULT_PAYMENT_METHOD_OPTION_ID:
          this.handleSetPaymentMethodAsDefault();
          break;
        default:
          break;
      }
    }
  }, {
    key: "buildMoreMenuOptions",
    value: function buildMoreMenuOptions() {
      this.moreOptionsMenuItems = [];
      if (this.canSetDefaultPaymentMethod && !this.isExternallyManagedArCustomer && !this.isLocked) {
        this.moreOptionsMenuItems.push({
          id: SET_AS_DEFAULT_PAYMENT_METHOD_OPTION_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.SET_AS_DEFAULT_PAYMENT_METHOD)
        });
      }
      this.moreOptionsMenuItems.push({
        id: 'VIEW_TRANSACTION_HISTORY',
        title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.VIEW_PAYMENT_HISTORY)
      });
      if (this.isActivePaymentMethod && this.canRemove && this.paymentMethod.Type !== parseInt(this.paymentInstrumentTypes.CURRENCY_ENTITLEMENT)) {
        this.moreOptionsMenuItems.push({
          id: REMOVE_PAYMENT_METHOD_OPTION_ID,
          title: i18n.translate(CustomerCareLocaleKeys.REMOVE)
        });
      }
      if (this.canRemove && this.canAnonymizePaymentMethod && (this.isCreditCard || this.isStripeAccount)) {
        this.moreOptionsMenuItems.push({
          id: ANONYMIZE_PAYMENT_METHOD_OPTION_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.ANONYMIZE_PAYMENT_METHOD_MENU_OPTION)
        });
      }
      if (this.paymentMethod.Status === PAYMENT_METHOD_STATUSES.REMOVED && this.canReactivate) {
        this.moreOptionsMenuItems.push({
          id: REACTIVATE_PAYMENT_METHOD_OPTION_ID,
          title: i18n.translate(CustomerCareLocaleKeys.REACTIVATE)
        });
      }
      if (this.canBlocklist && showAddToBlocklist(this.paymentMethod)) {
        this.moreOptionsMenuItems.push({
          id: ADD_TO_BLOCKLIST_MENU_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.MODALS.ADD_TO_BLOCKLIST_MENU_TEXT)
        });
      }
      if (this.canBlocklist && showRemoveFromBlocklist(this.paymentMethod)) {
        this.moreOptionsMenuItems.push({
          id: REMOVE_FROM_BLOCKLIST_MENU_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.MODALS.REMOVE_FROM_BLOCKLIST_MENU_TEXT)
        });
      }
      if (this.canBlocklist && showAddToAllowlist(this.paymentMethod)) {
        this.moreOptionsMenuItems.push({
          id: ADD_TO_ALLOWLIST_MENU_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.MODALS.ADD_TO_ALLOWLIST_MENU_TEXT)
        });
      }
      if (this.canBlocklist && showRemoveFromAllowlist(this.paymentMethod)) {
        this.moreOptionsMenuItems.push({
          id: REMOVE_FROM_ALLOWLIST_MENU_ID,
          title: i18n.translate(CustomerCareLocaleKeys.E_WALLET.MODALS.REMOVE_FROM_ALLOWLIST_MENU_TEXT)
        });
      }
    }
  }, {
    key: "handleCloseUpdateSubscriptionsConfirmationPopup",
    value: function handleCloseUpdateSubscriptionsConfirmationPopup() {
      updateSubscriptionsConfPopupApi.close();
    }
  }, {
    key: "handleResultActivatePaymentMethodErrorPopup",
    value: function handleResultActivatePaymentMethodErrorPopup() {
      activatePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseActivatePaymentMethodErrorPopup",
    value: function handleCloseActivatePaymentMethodErrorPopup() {
      activatePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseRemovePaymentMethodConfirmationPopup",
    value: function handleCloseRemovePaymentMethodConfirmationPopup() {
      removePaymentMethodConfPopupApi.close();
    }
  }, {
    key: "handleResultRemovePaymentMethodErrorPopup",
    value: function handleResultRemovePaymentMethodErrorPopup() {
      removePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseRemovePaymentMethodErrorPopup",
    value: function handleCloseRemovePaymentMethodErrorPopup() {
      removePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseAnonymizePaymentMethodConfirmationPopup",
    value: function handleCloseAnonymizePaymentMethodConfirmationPopup() {
      anonymizePaymentMethodConfPopupApi.close();
    }
  }, {
    key: "handleResultAnonymizePaymentMethodErrorPopup",
    value: function handleResultAnonymizePaymentMethodErrorPopup() {
      anonymizePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseAnonymizePaymentMethodErrorPopup",
    value: function handleCloseAnonymizePaymentMethodErrorPopup() {
      anonymizePaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleResultSetDefaultPaymentMethodErrorPopup",
    value: function handleResultSetDefaultPaymentMethodErrorPopup() {
      setDefaultPaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseSetDefaultPaymentMethodErrorPopup",
    value: function handleCloseSetDefaultPaymentMethodErrorPopup() {
      setDefaultPaymentMethodErrorPopupApi.close();
    }
  }, {
    key: "handleCloseBwModalPopupConfigErrorPopup",
    value: function handleCloseBwModalPopupConfigErrorPopup() {
      bwModalErrorPopupApi.close();
    }
  }]);
}();
export default {
  bindings: {
    activatePaymentInstrument: '&',
    braintreeMethodTypesLoaded: '<',
    brandableCurrenciesLoaded: '<',
    currentCustomerId: '<',
    currentPaymentMethodIsDirectSource: '<',
    currentSubHasEditPermission: '<',
    defaultPaymentMethodHasSubscriptions: '<',
    defaultPaymentMethodIsReadOnly: '<',
    editPaymentMethod: '<',
    fetchCodeType: '&',
    autopayEnableForPaymentMethod: '<',
    isEwalletEditable: '<',
    isExternallyManagedArCustomer: '<',
    lastAttemptError: '<',
    onPaymentMethodRemoved: '&',
    onPaymentMethodUpdated: '&',
    paymentMethod: '<',
    paymentMethodDetails: '<',
    paymentMethodRemove: '&',
    paymentMethodAnonymize: '&',
    onPaymentMethodAnonymized: '&',
    paymentMethodType: '<',
    setPaymentInstrumentDefault: '&',
    setPaymentInstrumentFilter: '&',
    stateGo: '&',
    userHasAdminPermission: '<',
    canAnonymizePaymentMethod: '<'
  },
  template: require('./ewallet.detail.html'),
  controller: EwalletDetailController,
  require: {
    parent: '^customer-ewallet'
  }
};